import { render, staticRenderFns } from "./WidgetHeader.vue?vue&type=template&id=71d7587b&scoped=true"
import script from "./WidgetHeader.vue?vue&type=script&lang=js"
export * from "./WidgetHeader.vue?vue&type=script&lang=js"
import style0 from "./WidgetHeader.vue?vue&type=style&index=0&id=71d7587b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7587b",
  null
  
)

export default component.exports